
module.exports = { 
      attributes: {},
    
      html: "<p>Magna consequat magna incididunt in. Pariatur sit velit pariatur cupidatat proident sint occaecat excepteur adipisicing. Reprehenderit mollit sunt velit dolore reprehenderit duis velit nulla est sunt sunt. In non tempor esse cillum mollit tempor laborum nisi labore elit. Deserunt duis Lorem consectetur ut ut incididunt consectetur ad minim occaecat nulla sint cupidatat.</p>\n",
     }